import { Spinner } from "@mylaunch/components/ui"
import { CarouselDots } from "@mylaunch/components/ui"
import { PWAInstallPrompt } from "@mylaunch/pwa/components"
import { PostsFeed } from "./posts-feed"
import { SectionHeader } from "./section-header"
import { PlansUpsell } from "./plans-upsell"
import { PartnersCarousel } from "./partners-carousel"
import { EventsCarousel } from "./events-carousel"
import { QueryBoundary } from "~/components/query-boundary"
import { SettingsItemSkeleton } from "~/components/settings-item-skeleton"

export function Feed() {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col gap-s bg-white border-b border-muted">
        {/* <SectionHeader title="Скидки от партнеров" linkHref="/discounts" /> */}
        {/* <SectionHeader title="Скидки от партнеров"/> */}
        {/* <Suspense fallback={<DiscountsSkeleton />}> */}
        {/*   <DiscountsList /> */}
        {/* </Suspense> */}
        <PWAInstallPrompt />
        <QueryBoundary loadingFallback={<SettingsItemSkeleton className="px-m" />}>
          <PlansUpsell />
        </QueryBoundary>
        <SectionHeader title="Партнеры" linkHref="/topic/7" />
        <QueryBoundary loadingFallback={<PartnersSkeleton />}>
          <PartnersCarousel />
        </QueryBoundary>
        <QueryBoundary loadingFallback={<EventsSkeleton />}>
          <EventsCarousel />
        </QueryBoundary>
      </div>
      <QueryBoundary loadingFallback={<PostsFeedSkeleton />}>
        <PostsFeed />
      </QueryBoundary>
    </div>
  )
}

function EventsSkeleton() {
  return (
    <div className="flex flex-col gap-xs">
      <div className="flex gap-s overflow-hidden px-m">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="rounded-md size-event-card shrink-0 bg-muted animate-pulse" />
        ))}
      </div>
      <CarouselDots count={5} activeIndex={-1}/>
    </div>
  )
}

function PartnersSkeleton() {
  return (
    <div className="flex overflow-hidden">
      {[1, 2, 3].map((i) => (
        <div key={i} className="w-partner-carousel-card ml-m h-group-img shrink-0 bg-muted animate-pulse rounded-md" />
      ))}
    </div>
  )
}

// function DiscountsSkeleton() {
//   return (
//     <div className="flex flex-col gap-xs">
//       <div className="flex gap-s overflow-hidden px-m">
//         {[1, 2, 3, 4, 5].map((i) => (
//           <div key={i} className="size-discount-card shrink-0 bg-muted animate-pulse" />
//         ))}
//       </div>
//       <CarouselDots count={5} activeIndex={-1}/>
//     </div>
//   )
// }

function PostsFeedSkeleton() {
  return (
    <div className="flex justify-center p-m">
      <Spinner className="size-12" />
    </div>
  )
}
